<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zdlaZH/tc-custom/9781452107684.jpg?1705231662873" alt="This image is the cover for the book Wine Bites"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wine Bites
      </h1>
      <p class="bookDescription body article font2">
        <b>Serve the perfectly paired snacks or small plates at your next celebration with this cookbook featuring more than seventy-five simple, scrumptious recipes.</b><br/><br/><i>Wine Bites</i> is an inspiring cookbook for those who entertain casually and frequently. More than seventy-five recipes for simple, tasty snacks include suggestions for an accessible wine to pair with each, while vivid color photographs demonstrate how easy these delectable dishes are to prepare. Step-by-step instructions for putting together a first-class cheese plate, creating a generous antipasti platter, or transforming pantry staples into hors d’oeuvres make this an indispensable resource for elevated entertaining.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Scott-Goodman, Kate Mathis
      </h2>
      
      <p class="authorDescription body article">Barbara Scott-Goodman is the author of <I>The Ski Country Cookbook</I> among others. She lives in New York City.<br/><br/>Kate Mathis is a commercial photographer based in New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f3cc600